const constants = {
  DATEFILTER: {
    SELECT_STARTDATE: 'Please select From date.',
    FUTURE_DATE: 'You cannot select a date in future yet!',
    INVALID_FROMDATE: 'Please select From date less than or same as To date',
    INVALID_TODATE: 'Please select From date less than or same as To date'
  },
  NODATAFOUND:'Data not found!'

};

export default constants;


// WEBPACK FOOTER //
// ./src/js/Messages.js